import { ComponentRef, Injectable, Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HeaderOutletComponent } from './header-outlet.component';

@Injectable({
  providedIn: 'root',
})
export class HeaderOutletService {
  private instance: any;

  containerRefInit$ = new BehaviorSubject(false);

  constructor() {}

  registerInstance(instance: HeaderOutletComponent<any>) {
    this.instance = instance;
  }

  getInstance<T>(): HeaderOutletComponent<T> {
    return this.instance;
  }

  onContainerRefInit() {
    this.containerRefInit$.next(true);
  }

  clear() {
    const instance = this.getInstance();
    instance?.destroyComponent();

    /**
     * 重新初始化containerRefInit$
     *
     * 登录后业务组件会重新订阅containerRefInit$，如果业务组件没有手动销毁订阅，会导致重复订阅
     * 这里为了保证不会被重复订阅，强制销毁containerRefInit$，并重新初始化
     */
    this.containerRefInit$.complete();
    this.containerRefInit$ = new BehaviorSubject(false);
  }
}
